import React from "react";
import logo from "assets/images/logo.png";
import { getCurrentYear } from "utils/number";
import { FacebookRounded, Instagram, Mail } from "@mui/icons-material";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <div
      className="pb-10 2xs:px-3 2xs:py-5 xl:px-20 xl:py-5"
      style={{ background: "#318162" }}
    >
      <div className="flex flex-wrap items-center justify-between">
        <div className="flex flex-col items-start">
          <Link to="/">
            <img src={logo} alt="logo" className="aspect-square w-16 md:w-28" />
          </Link>
          <p className="mb-5 md:mb-0">
            © {getCurrentYear} MariTiny Official Site. All rights reserved
          </p>
        </div>
        <div className="mr-10 md:mr-0 mb-8 1xs:mb-0">
          <ul
            className="list-none flex flex-col gap-3"
            style={{ paddingLeft: 0 }}
          >
            <li className="mb-1">
              <b>Products</b>
            </li>
            <li>
              <Link to="/shop/marimo%20moss%20ball">Marimo moss ball</Link>
            </li>
            <li>
              <Link to="/shop/aquarium">Aquarium</Link>
            </li>
            <li>
              <Link to="/shop/decor">Decorations</Link>
            </li>
          </ul>
        </div>
        <div className="flex flex-col gap-3">
          <b className="mb-1">Get in touch</b>
          <a href="tel:0946704225">0946704225</a>
          <a
            href="https://www.google.com/maps/place/University+of+Foreign+Language+Studies+-+University+of+%C4%90%C3%A0+N%E1%BA%B5ng/@16.0329252,108.2108738,16.37z/data=!4m20!1m13!4m12!1m4!2m2!1d108.1547262!2d16.0811611!4e1!1m6!1m2!1s0x31421993058c6045:0x4dbbb9ccec61fee3!2sdai+hoc+ngoai+ngu+da+nang!2m2!1d108.2116631!2d16.0345824!3m5!1s0x31421993058c6045:0x4dbbb9ccec61fee3!8m2!3d16.0345824!4d108.2116631!16s%2Fg%2F120ql100"
            target="_blank"
            rel="noreferrer"
          >
            130 Luong Nhu Hoc Street
          </a>
          <div className="flex gap-2">
            <a
              href="https://www.facebook.com/profile.php?id=100070197009860"
              target="_blank"
              rel="noreferrer"
            >
              <FacebookRounded />
            </a>
            <a
              href="https://www.instagram.com/maritinyshop/"
              target="_blank"
              rel="noreferrer"
            >
              <Instagram />
            </a>
            <a
              href="mailto:lkha.5023@gmail.com?subject = Feedback&body = Message"
              target="_blank"
              rel="noreferrer"
            >
              <Mail />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;
